export enum FriendshipStatusType {
  Established = 'established',
  RequestSent = 'request_sent',
  RequestReceived = 'request_received',
  Foreign = 'foreign',
}

interface FriendshipStatusInterface {
  type: FriendshipStatusType;
  isBlocked: boolean;
}

export class FriendshipStatus implements FriendshipStatusInterface {
  type: FriendshipStatusType;
  isBlocked: boolean;

  constructor(type: FriendshipStatusType, isBlocked: boolean) {
    this.type = type;
    this.isBlocked = isBlocked;
  }
}
